import { Adresse } from '../../../identite/shared/classes/adresse';
import { Description } from '../../../description/shared/classes/description';
import { Annonce } from './annonce';
import { Photo } from '../../../photo/shared/classes/photo';
import { TypeTransaction } from './type_transaction';
import { TypeBien } from './type_bien';
import { formatDate } from '@angular/common';
import { TypePassation } from './type_passation';
import { BatimentProprietaire } from './batiment-proprietaire';
import { Diagnostic } from './diagnostic';
import {MaitreOuvrageProjet} from './maitre-ouvrage-projet';
import { batimentDetails } from './batiment-details';

export class Batiment {

    id: string = null;
    ref: string;
    ref_metier: string;
    titre: string;
    url: string;
    statut: string;
    draft: string;
    adresses_id: string;
    adresse: Adresse;
    acl_resources_id: string;
    roles_id_commercial: string;
    roles_id_proprietaire: string;
    date_commit: string;
    date_update: string;
    readonly: string;
    libelle_projet: string;
    achat_type: string;
    projet_type: string;
    orientation: string;
    visite_virtuelle: string;
    annee_construction: string;
    disponibilite: string;
    date_entree: string;
    disponible_le: string;
    agence_bureaux_id: string;
    description = '';
    budget: string;
    photo: Photo;
    tct_id: string;
    tpb_id: string;
    ref_auto: boolean;
    archive: string;
    cacher_prix: boolean;
    type_transaction: TypeTransaction;
    type_passation: TypePassation;
    type_bien: TypeBien;
    tpt_id: string;
    computed_name: string;
    statut_projet: string;
    proprietaires: BatimentProprietaire[];
    descriptions: Description[];
    diagnostics: Diagnostic;
    annonce: Annonce;
    maitre_ouvrage_projet: MaitreOuvrageProjet[];
    projet_id;
    prix_terrain_m2: number;
    frais_architecte: number;
    construction_pourcentage: number;
    frais_constructeur: number;
    ind_id: string;
    ind_indice: string;
    last_ind_id: string;
    last_ind_indice: string;
    fixed_ind: boolean;
    code_chantier: string;
    code_terrain: string;
    taxe: number;
    z16ProChamps: Array<any> = [];
    batiment_details: batimentDetails;
    date_update_prix: string;
    nb_etages: string;
    methode_calcul: number;
    street_number: string;
    route: string;
    postal_code: string;
    locality: string;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.id                         = data['id'] ? data['id'] : null;
        this.ref                        = data['ref'] ? data['ref'] : null;
        this.ref_metier                 = data['ref_metier'] ? data['ref_metier'] : null;
        this.titre                      = data['titre'] ? data['titre'] : null;
        this.url                        = data['url'] ? data['url'] : null;
        this.statut                     = data['statut'] ? data['statut'] : null;
        this.draft                      = data['draft'] ? data['draft'] : null;
        this.acl_resources_id           = data['acl_resources_id'] ? data['acl_resources_id'] : null;
        this.roles_id_commercial        = data['roles_id_commercial'] ? data['roles_id_commercial'] : null;
        this.date_commit                = data['date_commit'] ? data['date_commit'] : null;
        this.date_update                = data['date_update'] ? data['date_update'] : null;
        this.readonly                   = data['readonly'] ? data['readonly'] : null;
        this.adresses_id                = data['adresses_id'] ? data['adresses_id'] : null;
        this.libelle_projet             = data['libelle_projet'] ? data['libelle_projet'] : null;
        this.achat_type                 = data['achat_type'] ? data['achat_type'] : 'ancien';
        this.projet_type                = data['projet_type'] ? data['projet_type'] : 'lotissement';
        this.orientation                = data['orientation'] ? data['orientation'] : null;
        this.visite_virtuelle           = data['visite_virtuelle'] ? data['visite_virtuelle'] : null;
        this.annee_construction         = data['annee_construction'] ? data['annee_construction'] : null;
        this.disponibilite              = data['disponibilite'] ? data['disponibilite'] : null;
        this.ref_auto                   = data['ref_auto'] && data['ref_auto'] === '1' ? true : false;
        this.computed_name              = data['computed_name'] ? data['computed_name'] : null;

        this.roles_id_proprietaire      = data['roles_id_proprietaire'] ? data['roles_id_proprietaire'] : null;
        this.date_entree                = data['date_entree'] ? data['date_entree'] : formatDate(new Date(), 'yyyy-MM-dd', 'en-US');
        this.disponible_le              = data['disponible_le'] ? data['disponible_le'] : null;
        this.agence_bureaux_id          = data['agence_bureaux_id'] ? data['agence_bureaux_id'] : null;
        this.budget                     = data['budget'] ? data['budget'] : null;
        this.photo                      = data['photo'] ? new Photo(data['photo']) : new Photo();
        this.tct_id                     = data['tct_id'] ? data['tct_id'] : null;
        this.tpb_id                     = data['tpb_id'] ? data['tpb_id'] : null;
        this.archive                    = data['archive'] ? data['archive'] : '0';
        this.cacher_prix                = data['cacher_prix'] ? (data['cacher_prix'] === '1' ? true : false) : false;
        this.type_transaction           = data['type_transaction'] ? new TypeTransaction(data['type_transaction']) : new TypeTransaction();
        this.type_passation             = data['type_passation'] ? new TypePassation(data['type_passation']) : new TypePassation();
        this.type_bien                  = data['type_bien'] ? new TypeBien(data['type_bien']) : new TypeBien();
        this.tpt_id                     = data['tpt_id'] ? data['tpt_id'] : null;
        this.statut_projet              = data['statut_projet'] ? data['statut_projet'] : null;

        this.adresse                    = data['adresse'] ? new Adresse(data['adresse']) : new Adresse();
        this.descriptions               = data['description'] ? data['description'] : [];
        this.diagnostics                = data['diagnostics_batiment'] ? new Diagnostic(data['diagnostics_batiment']) : new Diagnostic();

        this.annonce                    = data['annonce'] ? new Annonce(data['annonce']) : new Annonce();
        this.maitre_ouvrage_projet      = data['maitre_ouvrage_projet'] ? data['maitre_ouvrage_projet'] : null;

        this.projet_id                  = data['projet_id'] ? data['projet_id'] : null;

        this.prix_terrain_m2            = data['prix_terrain_m2'] ? data['prix_terrain_m2'] : null;
        this.frais_architecte           = data['frais_architecte'] ? data['frais_architecte'] : null;

        this.construction_pourcentage   = data['construction_pourcentage'] ? data['construction_pourcentage'] : null;
        this.frais_constructeur         = data['frais_constructeur'] ? data['frais_constructeur'] : null;

        this.ind_id                     = data['ind_id'] ? data['ind_id'] : null;
        this.ind_indice                 = data['ind_indice'] ? data['ind_indice'] : null;
        this.last_ind_id                = data['last_ind_id'] ? data['last_ind_id'] : null;
        this.last_ind_indice            = data['last_ind_indice'] ? data['last_ind_indice'] : null;
        this.fixed_ind                  = data['fixed_ind'] ? data['fixed_ind'] === '1' : null;

        this.code_chantier              = data['code_chantier'] ? data['code_chantier'] : null;
        this.code_terrain               = data['code_terrain'] ? data['code_terrain'] : null;
        this.taxe                       = data['taxe'] ? data['taxe'] : 0;
        this.batiment_details           = data['batiment_details'] ? new batimentDetails(data['batiment_details']) : null;
        this.date_update_prix           = data['date_update_prix'];
        this.nb_etages                  = data['nb_etages'] ? data['nb_etages'] : null;
        this.methode_calcul             = data['methode_calcul'] ? data['methode_calcul'] : null;
        this.street_number              = data['street_number'] ? data['street_number'] : null;
        this.route                      = data['route'] ? data['route'] : null;
        this.postal_code                = data['postal_code'] ? data['postal_code'] : null;
        this.locality                   = data['locality'] ? data['locality'] : null;
    }

}
